class ProductTaxModel {
    productTaxId?: number;
    taxName:string;
    cgstPercentage?: string;
    sgstPercentage?: string;
    igstPercentage?:string;
    
}
export default ProductTaxModel;
